export enum MppPhoneNumberErrors {
  NOT_A_NUMBER = 'NOT_A_NUMBER',
  INVALID_COUNTRY = 'INVALID_COUNTRY',
  INVALID_LENGTH = 'INVALID_LENGTH',
  TOO_SHORT = 'TOO_SHORT',
  TOO_LONG = 'TOO_LONG',
}
